import {
  Disclosure,
  DisclosureButton,
  DisclosurePanel,
} from "@headlessui/react";
import { ChevronDownIcon, ChevronUpIcon } from "@heroicons/react/outline";
import { RadioGroup, RadioGroupElement } from "components/RadioGroup";
import { cx } from "utils";
import { Tooltip } from "components/Tooltip";

interface CrawlerNotificationPreferencesProps {
  watchedValues: any;
  setValue: any;
}

const CrawlerNotificationPreferences = ({
  watchedValues,
  setValue,
}: CrawlerNotificationPreferencesProps) => (
  <Disclosure>
    {({ open }) => (
      <>
        <DisclosureButton
          className={cx(
            "flex flex-row items-center w-full transition-colors duration-50 p-4"
          )}
        >
          {open ? (
            <ChevronUpIcon className="h-4 w-4 mr-4" />
          ) : (
            <ChevronDownIcon className="h-4 w-4 mr-4" />
          )}
          Notification Preferences
        </DisclosureButton>

        <DisclosurePanel className="flex flex-col p-4" style={{ marginTop: 0 }}>
          <div className="mb-4">
            <p className="text-sm text-gray-600 mb-4">
              Choose how you want to be notified about your crawler runs.
            </p>

            <div className="space-y-6">
              {/* Run Completion Notifications */}
              <div>
                <label className="flex items-center text-sm font-medium text-gray-700 mb-3">
                  <Tooltip content="Choose how often to receive email notifications about your crawler runs. Daily/Weekly options aggregate multiple runs into summary emails.">
                    Notify me about run completion
                  </Tooltip>
                </label>
                <RadioGroup
                  name="notification"
                  value={watchedValues.notification}
                  onChange={(value) => setValue("notification", value)}
                >
                  <div className="flex flex-row flex-wrap gap-4">
                    <RadioGroupElement value="never" label="Never" />
                    <RadioGroupElement value="with_every_run" label="With every run" />
                    <RadioGroupElement value="daily" label="Daily" />
                    <RadioGroupElement value="weekly" label="Weekly" />
                  </div>
                </RadioGroup>
              </div>

            </div>
          </div>
        </DisclosurePanel>
      </>
    )}
  </Disclosure>
);

export default CrawlerNotificationPreferences;